import { marshalTypedArray } from "./marshalTypedArraysInObject";

/**
 * A JSON.stringify that handles typed arrays
 */
export function stringifyWithTypedArraysInObject(object: object): string {
  return JSON.stringify(
    object,
    (_, value) => {
      if (ArrayBuffer.isView(value)) {
        return marshalTypedArray(value);
      }
      return value;
    },
    "  ",
  );
}
